<template>
  <div>
    <div class="background"></div>
    <div class="dialog">
      <div class="mainContent">
        <p class="close">
          <span class="closeButton" @click="onClose">✖</span>
        </p>
        <p class="login-hint">ポイント関連機能の利用には、<br>ログインまたアプリダウンロードが必要です。</p>
        <div class="title">ログイン</div>
        <p class="error">{{ errorMessage }}</p>
        <InputMailAddress @input="changeMailAddress" />
        <InputPassword @input="changePassword" />
        <ButtonTextLink
          class="button"
          @click-text="onClickLogin"
          text="ログイン"
        />
        <div class="bottom">
          <TextLink
            @click="onClickForgotPawssword"
            text="パスワードを忘れた場合"
          />
          <TextLink @click="onClickSignup" text="新規登録をする" />
          <hr v-if="isAndroidOrIphone" class="divider">
          <p v-if="isAndroidOrIphone" class="login-hint">※アプリ版は、ログインなしでも、<br>ポイント関連機能をご利用いただけます。</p>
          <div v-if="isAndroidOrIphone" class="center">
            <AppBanner/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import InputMailAddress from "@/components/Input/InputMailAddress";
import InputPassword from "@/components/Input/InputPassword";
import TextLink from "@/components/Text/TextLink";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";
import AppBanner from "@/components/Organisms/AppBanner";
import Firebase from "./../../firebase";

export default {
  name: "signin-modal",
  components: {
    InputMailAddress,
    InputPassword,
    TextLink,
    ButtonTextLink,
    AppBanner,
  },
  data() {
    return {
      mailadress: undefined,
      password: undefined,
      errorMessage: undefined,
    };
  },
  computed: {
    isAndroidOrIphone() {
      return navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
  },
  methods: {
    ...mapMutations(["loadingStartMini", "loadingEndMini", "setModal"]),
    changeMailAddress(value) {
      this.mailadress = value.value;
    },
    changePassword(value) {
      this.password = value.value;
    },
    onClickForgotPawssword() {
      this.setModal("forgotpassword");
    },
    onClickSignup() {
      this.setModal("signup");
    },
    async onClickLogin() {
      this.loadingStartMini();
      let ok = false;
      await Firebase.login(this.mailadress, this.password)
        .then(() => {
          ok = true;
        })
        .catch((result) => {
          if (result.code === "auth/user-not-found") {
            this.errorMessage =
              "ログインに失敗しました。メールアドレス・パスワードを確認してください。";
          } else if (result.code === "auth/wrong-password") {
            this.errorMessage =
              "ログインに失敗しました。メールアドレス・パスワードを確認してください。";
          } else {
            this.errorMessage = "ログインに失敗しました。";
          }
        });

      if (!ok) {
        this.loadingEndMini();
        return;
      }

      await Firebase.getIsLoggednInWithFirebaseAuth();
      await Firebase.getRegistraion();
      this.loadingEndMini();
      this.onClose();

      if (location.pathname !== "/") {
        this.$router.push({ name: "Main" });
      }

      Firebase.putLog({
        ActionType: "Login",
      });
    },
    onClose() {
      this.setModal("");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.mainContent {
  padding: 0 8px;
  .error {
    text-align: center;
    color: #ff7c86;
  }
}

.bottom {
  margin-top: 0vh;
}

.close {
  text-align: right;
  margin: 0;
  .closeButton {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}
.title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-align: center;
}

.button {
  width: 100%;
}

.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.dialog {
  position: fixed;
  display: flex;
  flex-direction: column;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-55%);
  background-color: white;
  z-index: 1001;
  width: 80vw;
  padding: 1rem;
  border-radius: 12px;
}
.login-hint {
  font-size: 0.6em;
  text-align: center;
}
.center {
  margin: auto;
  text-align: center;
  left: 0;
  right: 0;
}
hr.divider {
  width: 5rem;
  border-top: 1px solid #bbb;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/SignInModal.vue